// Search
export const IDI_CALENDAR_SEARCH_START_LOADING = "IDI_CALENDAR_SEARCH_START_LOADING";
export const IDI_CALENDAR_SEARCH_END_LOADING = "IDI_CALENDAR_SEARCH_END_LOADING";
export const IDI_CALENDAR_SEARCH_LOADED = "IDI_CALENDAR_SEARCH_LOADED";
export const SET_IDI_CALENDAR_FILTER = "SET_IDI_CALENDAR_FILTER";
